
import Dashboard from "views/pages/dashboards/AdminDashboard.jsx";
import AdminList from "views/pages/admin/List.jsx";
import AdminDetails from "views/pages/admin/Details.jsx";
import AdminCreate from "views/pages/admin/Create.jsx";
import AdminEdit from "../views/pages/admin/Edit";
import TenantSettingList from "../views/pages/tenantSetting/List";
import AdminSettings from "../views/pages/settings/AdminSettings";
import CompanyList from "../views/pages/company/List";
import CompanyCreate from "../views/pages/company/Create";
import CompanyEdit from "../views/pages/company/Edit";
import ContentList from "../views/pages/content/List";
import ContentDetails from "../views/pages/content/Details";
import ContentEdit from "../views/pages/content/Edit";
import ContentCreate from "../views/pages/content/Create";
import ContactCreate from "../views/pages/contact/Create";
import ContactList from "../views/pages/contact/List";
import ContactDetails from "../views/pages/contact/Details";
import ContactEdit from "../views/pages/contact/Edit";
import ReportList from "../views/pages/meetingReport/ReportList";
import MeetingList from "../views/pages/report/List";
import MeetingDetails from "../views/pages/report/Details";
import MeetingEdit from "../views/pages/report/Edit";
import MeetingCreate from "../views/pages/report/Create";
import ProjectList from "../views/pages/project/List";
import ProjectCreate from "../views/pages/project/Create";
import ProjectDetails from "../views/pages/project/Details";
import CompanyDetails from "../views/pages/company/Details";
import routeVisibleForRole from "../util/routeVisibleForRole";
import NextStepsComplete from "../views/pages/nextSteps/NextStepsComplete";
import ReportListByCompany from "../views/pages/report/ReportListByCompany";
import SummaryList from "../views/pages/summary/List";
import ProjectEdit from "../views/pages/project/Edit";
import Profile from "../views/pages/auth/Profile";
import EventList from "../views/pages/event/List";
import EventCreate from "../views/pages/event/Create";
import EventEdit from "../views/pages/event/Edit";
import AboutUs from "../views/AboutUs";
import LeadsList from "../views/pages/leads/LeadsList";
import LeadDetails from "../views/pages/leads/LeadDetails";
import driveRoutes from './driveRoutes';
import utilService from "../services/utilService";
import ReviewCompanyDetails from "../views/pages/subscribedUser/reviewCompany/Details";
import ReviewCompanyEdit from "../views/pages/subscribedUser/reviewCompany/Edit";
import ReviewCompanyList from "../views/pages/subscribedUser/reviewCompany/List";
import ReviewCompanyCreate from "../views/pages/subscribedUser/reviewCompany/Create";
import ReviewContactDetails from "../views/pages/subscribedUser/reviewContact/Details";
import ReviewContactEdit from "../views/pages/subscribedUser/reviewContact/Edit";
import ReviewContactCreate from "../views/pages/subscribedUser/reviewContact/Create";
import ReviewContactList from "../views/pages/subscribedUser/reviewContact/List";

const adminRoutes = [
    {
        collapse: false,
        path: "/dashboard",
        name: "Dashboard",
        icon: "fas fa-window-restore",
        component: Dashboard,
        layout: "/crm",
        invisible: false
    },
    {
    collapse: true,
    state: 'crmCollapse',
    name: 'CRM',
    icon: 'fa fa-bar-chart',
    invisible: !routeVisibleForRole(["ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_ADMIN","ROLE_LEVEL3","ROLE_LEVEL2","ROLE_LEVEL1","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
    views: [
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "userCollapse", // State key for controlling collapse
            name: "Users", // Name of the collapsible group
            icon: "fa fa-users", // Icon for the collapsible group
            invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN"]),
            views: [
                {
                    collapse: false,
                    path: "/list",
                    name: "List All Users",
                    icon: " ",
                    component: AdminList,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_SUPER_ADMIN"]),
                },
                {
                    collapse: false,
                    path: "/show/:uniqueId",
                    name: "Admin Details",
                    icon: " ",
                    component: AdminDetails,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/create",
                    name: "Create User",
                    icon: " ",
                    component: AdminCreate,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN"]),
                },
                {
                    collapse: false,
                    path: "/edit/:uniqueId",
                    name: "Edit Admin",
                    icon: " ",
                    component: AdminEdit,
                    layout: "/crm",
                    invisible: true,
                },
            ],
        },
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "contentCollapse", // State key for controlling collapse
            name: "Content", // Name of the collapsible group
            icon: "fa fa-regular fa-newspaper ", // Icon for the collapsible group
            invisible: !utilService.isXgAdmin(),
            views: [ // Array of routes that are part of this collapsible group
                {
                    collapse: false,
                    path: "/content/list",
                    name: "List All Content",
                    icon: " ",
                    component: ContentList,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_SUPER_ADMIN"]),
                },
                {
                    collapse: false,
                    path: "/content/create",
                    name: "Content Create",
                    icon: " ",
                    component: ContentCreate,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN"]),
                },
                {
                    collapse: false,
                    path: "/content/approve",
                    name: "Approve Content",
                    icon: " ",
                    component: AdminList,
                    layout: "/crm",
                    invisible: true
                },
                {
                    collapse: false,
                    path: "/content/show/:uniqueId",
                    name: "Content Details",
                    icon: " ",
                    component: ContentDetails,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/content/edit/:uniqueId",
                    name: "Content Edit",
                    icon: " ",
                    component: ContentEdit,
                    layout: "/crm",
                    invisible: true,
                },
            ],
        },
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "companyCollapse", // State key for controlling collapse
            name: "Company", // Name of the collapsible group
            icon: "fa fa-solid fa-building ", // Icon for the collapsible group
            invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"]),
            views: [ // Array of routes that are part of this collapsible group
                {
                    collapse: false,
                    path: "/company/show/:uniqueId",
                    name: "Company Details",
                    icon: " ",
                    component: CompanyDetails,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/company/edit/:uniqueId",
                    name: "Company Edit",
                    icon: " ",
                    component: CompanyEdit,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/company/list",
                    name: "List All Companies",
                    icon: " ",
                    component: CompanyList,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"])
                },
                {
                    collapse: false,
                    path: "/company/create",
                    name: "Create New Company",
                    icon: " ",
                    component: CompanyCreate,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"]),
                },
            ],
        },
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "contactCollapse", // State key for controlling collapse
            name: "Contact Database", // Name of the collapsible group
            icon: "fa fa-solid fa-address-book ", // Icon for the collapsible group
            invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"]),
            views: [
                {
                    collapse: false,
                    path: "/contact/show/:uniqueId",
                    name: "Contact Details",
                    icon: " ",
                    component: ContactDetails,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/contact/edit/:uniqueId",
                    name: "Contact Edit",
                    icon: " ",
                    component: ContactEdit,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/contact/create/:uniqueId",
                    name: "Contact Create",
                    icon: " ",
                    component: ContactCreate,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    collapse: false,
                    path: "/contact/list",
                    name: "List All Contacts",
                    icon: " ",
                    component: ContactList,
                    layout: "/crm",
                },
                {
                    collapse: false,
                    path: "/contact/create/",
                    name: "Create New Contact",
                    icon: " ",
                    component: ContactCreate,
                    layout: "/crm",
                    invisible: false,
                },
            ],
        },
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "projectCollapse", // State key for controlling collapse
            name: "Project Database", // Name of the collapsible group
            icon: "fa fa-briefcase ", // Icon for the collapsible group
            invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3", "ROLE_LEVEL2"]),
            views: [
                {
                    path: "/project/list",
                    name: "List All Projects",
                    icon: " ",
                    component: ProjectList,
                    layout: "/crm",
                    invisible: false
                },
                {
                    path: "/project/create",
                    name: "Create New Project",
                    icon: " ",
                    component: ProjectCreate,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN"])
                },
                {
                    path: "/project/show/:uniqueId",
                    name: "Project Show",
                    icon: " ",
                    component: ProjectDetails,
                    layout: "/crm",
                    invisible: true
                },
                {
                    path: "/project/edit/:uniqueId",
                    name: "Project Edit",
                    icon: " ",
                    component: ProjectEdit,
                    layout: "/crm",
                    invisible: true
                },
            ],
        },
        {
            collapse: true, // Indicates that this is a collapsible group
            state: "reportCollapse", // State key for controlling collapse
            name: "Reports", // Name of the collapsible group
            icon: "fa fa-print ", // Icon for the collapsible group
            invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3", "ROLE_LEVEL2", "ROLE_LEVEL1"]),
            views: [
                {
                    path: "/meetingReport/create/:companyId",
                    name: "Meeting",
                    icon: " ",
                    component: MeetingCreate,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    path: "/meetingReport/list",
                    name: "List All Meetings",
                    icon: " ",
                    component: MeetingList,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"])
                },
                {
                    path: "/meetingReport/show/:uniqueId",
                    name: "Meeting",
                    icon: " ",
                    component: MeetingDetails,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    path: "/summary/:companyUid",
                    name: "Summaries",
                    icon: " ",
                    component: SummaryList,
                    layout: "/crm",
                    invisible: true
                },
                {
                    path: "/projectSummaries/:projectUid",
                    name: "Summaries By Project",
                    icon: " ",
                    component: SummaryList,
                    layout: "/crm",
                    invisible: true
                },
                {
                    path: "/summary",
                    name: "List All Summaries",
                    icon: " ",
                    component: SummaryList,
                    layout: "/crm",
                    invisible: false
                },
                {
                    path: "/meetingReport/create",
                    name: "Create New Report",
                    icon: " ",
                    component: MeetingCreate,
                    layout: "/crm",
                    invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL3"]),
                },
                {
                    path: "/meetingReport/company/:uniqueId",
                    name: "Meeting",
                    icon: " ",
                    component: ReportListByCompany,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    path: "/meetingReport/edit/:uniqueId",
                    name: "Meeting",
                    icon: " ",
                    component: MeetingEdit,
                    layout: "/crm",
                    invisible: true,
                },
                {
                    path: "/nextSteps/list/",
                    name: "Tasks",
                    icon: " ",
                    component: NextStepsComplete,
                    layout: "/crm",
                    invisible: true
                },
                {
                    path: "/project/listOld/",
                    name: "Project Events",
                    icon: " ",
                    component: ReportList,
                    layout: "/crm",
                    invisible: true,
                },


            ],
        }

    ]
},
    {
        collapse: true, // Indicates that this is a collapsible group
        state: "leadsCollapse", // State key for controlling collapse
        name: "Leads Management", // Name of the collapsible group
        icon: " fa fa-cogs", // Icon for the collapsible group
        invisible: !utilService.isXgAdmin(),
        views: [
            {
                collapse: false,
                path: "/leads",
                name: "Leads",
                icon: "fa fa-gears ",
                component: LeadsList,
                layout: "/crm",
                invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ADMIN"]),
            },
            {
                collapse: false,
                path: "/lead/show/:uniqueId",
                name: "Lead Details",
                icon: "fa fa-gears ",
                component: LeadDetails,
                layout: "/crm",
                invisible: true,
            },

        ],
    },
    ...driveRoutes,
    {
        collapse: true, // Indicates that this is a collapsible group
        state: "adminCollapse", // State key for controlling collapse
        name: "Admin Settings", // Name of the collapsible group
        icon: " fa fa-cogs", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN"]),
        views: [
            {
                path: "/tenantSetting/list",
                name: "Tenant Setting",
                icon: " ",
                component: TenantSettingList,
                layout: "/crm",
                invisible: !routeVisibleForRole(["ROLE_TENANT_ADMIN"])
            },

        ],
    },
    {
        collapse: false,
        path: "/settings",
        name: "Settings",
        icon: "fa-solid fa-gears ",
        component: AdminSettings,
        layout: "/crm",
        invisible: true,
    },
    {
        collapse: false,
        path: "/dashboard",
        name: "Dashboard",
        icon: " ",
        component: Dashboard,
        layout: "/crm",
        invisible: true
    },
    {
        collapse: false,
        path: "/profile",
        name: "Profile",
        icon: " ",
        component: Profile,
        layout: "/crm",
        invisible: true
    },
    {
        collapse: false,
        path: "/event/list",
        name: "Event List",
        icon: " ",
        component: EventList,
        layout: "/crm",
        invisible: true
    },
    {
        collapse: false,
        path: "/event/create",
        name: "Event Create",
        icon: " ",
        component: EventCreate,
        layout: "/crm",
        invisible: true
    },
    {
        collapse: false,
        path: "/event/edit/:uniqueId",
        name: "Event Edit",
        icon: " ",
        component: EventEdit,
        layout: "/crm",
        invisible: true
    },
    {
        collapse: false,
        path: "/aboutUs",
        name: "About Us",
        icon: " ",
        component: AboutUs,
        layout: "/crm",
        invisible: true
    },

];


export default adminRoutes;
